const headbandStepType: any = {
    payment: [
        {key: 'informations', label: 'Informations', toActivate: ['informations', 'confirmation', 'payment']},
        {key: 'confirmation', label: 'Confirmation', toActivate: ['confirmation', 'payment']},
        {key: 'payment', label: 'Paiement', toActivate: ['payment']},
    ],
};

export default headbandStepType;
